import Util from '../../libs/util';
import wpdmIcons from "../../libs/icons";

const {InnerBlocks, InspectorControls, BlockControls, ColorPalette, RichText, AlignmentToolbar, MediaUpload, PanelColorSettings} = wp.editor;
const {
    TextControl,
    SelectControl,
    ServerSideRender,
    Modal,
    Button,
    PanelBody,
    PanelRow,
    RangeControl,
    ToggleControl,
    Panel,
    TreeSelect,
    RadioControl,
    FontSizePicker,
    withFallbackStyles,
    IconButton,
    Dashicon,
    Toolbar,
    FormToggle,
    ResizableBox
} = wp.components;

const { registerBlockType } = wp.blocks;
const { Fragment } = wp.element;


const { __ } = wp.i18n;

registerBlockType( 'download-manager/section', {

    title: 'Section',

    description: 'HTML Section',

    keywords: [
        __( 'bootstrap jumbotron component' ),
        __( 'call-to-action ui' ),
        __( 'call2action' ),
    ],

    icon: wpdmIcons.section(),

    category: 'wpdm-blocks',

    attributes: {
        wideContent: {
            type: 'boolean',
            default: false
        },
        sectionBG: {
            type: 'string',
            default: '#E9ECEF'
        },
        sectionBGx: {
            type: 'string',
            default: '#E9ECEF'
        },

        sectionBGAlpha: {
            type: 'number',
            default: 95
        },

        bgCS1: {
            type: 'number',
            default: 0
        },

        bgCS2: {
            type: 'number',
            default: 100
        },

        gradAngle: {
            type: 'number',
            default: 45
        },

        sectionBGImage: {
            type: 'string',
            default: null
        },

        sectionBGSize: {
            type: 'string',
            default: 'bg-cover'
        },

        sectionBGRepeat: {
            type: 'string',
            default: 'bg-no-repeat'
        },

        sectionBGImageID: {
            type: 'string',
            default: null
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, setAttributes, className}) {


        const onSelectImage = img => {
            setAttributes( {
                sectionBGImage: img.url
            } );
        };


        const onRemoveImage = () => {
            setAttributes({
                sectionBGImage: null,
                //imgAlt: null,
            });
        };


        /* Default colors */
        const defaultColors = Util.defaultColor();


        const rgba1 = Util.hexToRgba(attributes.sectionBG, attributes.sectionBGAlpha);
        const rgba2 = Util.hexToRgba(attributes.sectionBGx, attributes.sectionBGAlpha);
        const cs1 = attributes.bgCS1+"%";
        const cs2 = attributes.bgCS2+"%";

        const overlay = "linear-gradient( "+ attributes.gradAngle +"deg, " + rgba1 + " "+ cs1 + ", " + rgba2 + " "+ cs2 + "),";

        if(attributes.sectionBGImage === null)
            attributes.sectionBGImage = "";

        const background = overlay +" " + "url("+attributes.sectionBGImage+")";

        const container = attributes.wideContent ? 'container-fluid' : 'container';

        return [

            <InspectorControls>
                <div className="w3eden">

                    <PanelBody initialOpen={ true }>

                        <FormToggle
                            id={"ever"}
                            checked={attributes.wideContent}
                            onChange={_wideContent => {
                                setAttributes({wideContent: _wideContent.target.checked});
                            }}
                        />
                        <label htmlFor={"ever"} style={{paddingLeft: "5px"}}> Full-width Content</label>

                    </PanelBody>

                    <PanelBody title={ __( 'Background Options' ) } initialOpen={ true }>


                        <div className={"panel panel-default"}>
                            <div className={"panel-heading"}>{__( 'Background Color Left' )}</div>
                            <div className={"panel-body"}>
                                <ColorPalette
                                    colors={defaultColors}
                                    disableAlpha={ false }
                                    label={ __( 'Background Color' ) }
                                    value={ attributes.sectionBG ? attributes.sectionBG : 'transparent' }
                                    onChange={ ( value ) => setAttributes( { sectionBG: value } ) }
                                />
                            </div>
                        </div>
                        <div className={"panel panel-default"}>
                            <div className={"panel-heading"}>{__( 'Background Color Right' )}</div>
                            <div className={"panel-body"}>
                                <ColorPalette
                                    colors={defaultColors}
                                    disableAlpha={ false }
                                    label={ __( 'Background Color' ) }
                                    value={ attributes.sectionBGx }
                                    onChange={ ( value ) => setAttributes( { sectionBGx: value } ) }
                                />
                            </div>
                        </div>
                        <div>
                            <label>Gradient Angle:</label><br/>
                            <RangeControl
                                value={ attributes.gradAngle }
                                onChange={ ( value ) => setAttributes( { gradAngle: value } ) }
                                min={ -270 }
                                max={ 360 }
                                step={ 1 }
                            />
                            <label>Opacity:</label><br/>
                            <RangeControl
                                value={ attributes.sectionBGAlpha }
                                onChange={ ( value ) => setAttributes( { sectionBGAlpha: value } ) }
                                min={ 0 }
                                max={ 100 }
                                step={ 1 }
                            />
                            <label>Color #1 Start:</label><br/>
                            <RangeControl
                                value={ attributes.bgCS1 }
                                onChange={ ( value ) => setAttributes( { bgCS1: value } ) }
                                min={ 0 }
                                max={ 100 }
                                step={ 1 }
                            />
                            <label>Color #2 Start:</label><br/>
                            <RangeControl
                                value={ attributes.bgCS2 }
                                onChange={ ( value ) => setAttributes( { bgCS2: value } ) }
                                min={ 0 }
                                max={ 100 }
                                step={ 1 }
                            />
                        </div>
                        <div className={"panel panel-default"}>
                            <div className={"panel-heading"}>{ __( 'Select a background image:' ) }</div>
                            <div className={"panel-body"}>

                                <MediaUpload
                                    onSelect={ onSelectImage }
                                    type="image"
                                    value={ attributes.sectionBGImage }
                                    render={ ( { open } ) => (
                                        <div>
                                            <IconButton
                                                className="ab-section-inspector-media"
                                                label={ __( 'Edit image' ) }
                                                icon="format-image"
                                                onClick={ open }
                                            >
                                                { __( 'Select Image' ) }
                                            </IconButton>

                                            { attributes.sectionBGImage && !! attributes.sectionBGImage.length && (
                                                <div>
                                                    <img src={attributes.sectionBGImage} />
                                                    <IconButton
                                                        className="ab-section-inspector-media"
                                                        label={ __( 'Remove Image' ) }
                                                        icon="dismiss"
                                                        onClick={ onRemoveImage }
                                                    >
                                                        { __( 'Remove' ) }
                                                    </IconButton>
                                                </div>
                                            ) }
                                        </div>
                                    ) }
                                >
                                </MediaUpload>
                            </div>
                        </div>
                        { attributes.sectionBGImage && !! attributes.sectionBGImage.length && (
                            <div>
                                <label>Background Size:</label><br/>
                                <SelectControl
                                    class="form-control wpdm-custom-select"
                                    value={ attributes.sectionBGSize }
                                    onChange={ ( value ) => setAttributes( { sectionBGSize: value } ) }
                                    options = { [
                                        { label: 'Auto', value: 'bg-auto' },
                                        { label: 'Cover', value: 'bg-cover' },
                                        { label: 'Contain', value: 'bg-contain' },
                                        { label: '100%', value: 'bg-100' },
                                    ] }
                                />
                                <label>Background Repeat:</label><br/>
                                <SelectControl
                                    class="form-control wpdm-custom-select"
                                    value={ attributes.sectionBGRepeat }
                                    onChange={ ( value ) => setAttributes( { sectionBGRepeat: value } ) }
                                    options = { [
                                        { label: 'No Repeat', value: 'bg-no-repeat' },
                                        { label: 'Repeat', value: 'bg-repeat' },
                                        { label: 'Repeat X', value: 'bg-repeat-x' },
                                        { label: 'Repeat Y', value: 'bg-repeat-y' },
                                    ] }
                                />
                            </div>
                        ) }


                    </PanelBody>


                </div>
            </InspectorControls>
            ,
            <section className={ "w3eden " + attributes.sectionBGRepeat + " " + attributes.sectionBGSize } style={{background: background }}>
                <div className={ container }>
                   <InnerBlocks
                       renderAppender={ () => ( <InnerBlocks.ButtonBlockAppender /> ) }
                   />
                </div>
            </section>

        ];
    },


    save({ attributes, className }) {

        const rgba1 = Util.hexToRgba(attributes.sectionBG, attributes.sectionBGAlpha);
        const rgba2 = Util.hexToRgba(attributes.sectionBGx, attributes.sectionBGAlpha);
        const cs1 = attributes.bgCS1+"%";
        const cs2 = attributes.bgCS2+"%";
        const overlay = "linear-gradient( "+ attributes.gradAngle +"deg, " + rgba1 + " "+ cs1 + ", " + rgba2 + " "+ cs2 + "),";

        if(attributes.sectionBGImage === null)
            attributes.sectionBGImage = "";

        const background = overlay +" " + "url("+attributes.sectionBGImage+")";

        const container = attributes.wideContent ? 'container-fluid' : 'container';

        return (
            <section  className={ "w3eden " + attributes.sectionBGRepeat + " " + attributes.sectionBGSize } style={{background: background }}>
                <div className={ container }>
                    <InnerBlocks.Content />
                </div>
            </section>
        );
    }
} );

